import { useParams } from "react-router-dom";
import { useApi } from "../../lib/useApi";
import { Loader, ErrorState } from "../../components/common/States";
import { CompanyFormLayout } from "./CompanyProfile";

export default function QrFeedback() {
  const { code } = useParams();
  const { data, loading, error } = useApi(`/public/qr/${code}`);
  if (loading) return <Loader />;
  if (error) return <div className="mx-auto max-w-lg px-4 py-16"><ErrorState message={error} /></div>;
  return <CompanyFormLayout data={data} qr={data.qr} />;
}
